import { systemKeyModifiers } from '@vue/test-utils/dist/constants/dom-events'
import { Module } from 'vuex'

const commonModule: Module<any, any> = {
    state: {
		activeTab: 'workspace'
	},

    actions: {
    },

    getters: {
    },

    mutations: {
    }
}

export default commonModule